import { article } from '@stereoagency/sanity-schema';

const orderedBuilder = article.schema.builder.orderBy(
  'datetime',
  'desc'
) as typeof article.schema.builder;

export const articlesQuery = orderedBuilder
  .pick(['datetime', 'slug', 'title', 'introduction', 'thumbnail'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies.resolveIn(['slug', 'name', 'type']).use()
  }))
  .select(0, 200)
  .use();
